import React from "react"

const BackgroundOverlay = () => {
  return (
    <div
      className="fixed inset-0 z-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5"
      style={{ pointerEvents: 'none' }}
    />
  )
}

export default BackgroundOverlay
